function getCommModes(radio) {
  if (radio == null) {
    return ['cellular'];
  }

  let iccid;
  let commModes;
  if (radio.get) {
    iccid = radio.get('iccid', null);
    commModes = radio.get('comm_modes', 0);
  } else {
    iccid = radio.iccid || null;
    commModes = radio.comm_modes || 0;
  }

  const modes = [];
  if ((commModes & 0b0100) != 0) {
    modes.push('wifi');
  }
  if ((commModes & 0b0001) != 0 && iccid != null) {
    modes.push('cellular');
  }
  if ((commModes & 0b0010) != 0) {
    modes.push('ethernet');
  }

  return modes;
}

export function isCellular(radio, isExclusive = false) {
  const modes = getCommModes(radio);

  if (radio == null) {
    return true; // Assume cellular if no radio exists
  }

  const isCellular = modes.includes('cellular');

  if (isExclusive) {
    return isCellular && modes.length === 1;
  }

  return isCellular;
}

export function isEthernet(radio, isExclusive = false) {
  const modes = getCommModes(radio);

  if (radio == null) {
    return false;
  }

  const isEthernet = modes.includes('ethernet');

  if (isExclusive) {
    return isEthernet && modes.length === 1;
  }

  return isEthernet;
}

export function isWiFi(radio, isExclusive = false) {
  const modes = getCommModes(radio);

  if (radio == null) {
    return false;
  }

  const isWiFi = modes.includes('wifi');

  if (isExclusive) {
    return isWiFi && modes.length === 1;
  }

  return isWiFi;
}
